import React from 'react';
import { ApplicationAction, IApplication, IAttachment, IVideoInterview } from '../types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api from '../API';
import { Box, Stack } from '@mui/material';
import GenericDialog from '../../Components/Modals/GenericDialog';
import { theme } from '../../../ThemeContext/ThemeObject';

export function DeleteAttachment({
  dispatch,
  isDialogOpen,
  selectedAttachment
}: {
  dispatch: React.Dispatch<ApplicationAction>;
  isDialogOpen: boolean;
  selectedAttachment: IAttachment | IVideoInterview;
}) {
  const queryClient = useQueryClient();
  const application = queryClient.getQueryData<IApplication>(['application']);
  const isVideoInterview = 'watch_interview_link' in selectedAttachment;
  const deleteApi = () => {
    if (!application || !selectedAttachment) return;
    if (isVideoInterview) {
      return Api.deleteVideoInterview(application.id);
    } else {
      return Api.deleteAttachment(application.job.id, application.id, selectedAttachment.id);
    }
  };
  const deleteAttachment = useMutation({
    mutationFn: async () => {
      if (application && selectedAttachment) {
        const { res } = await deleteApi();
        return res;
      }
    },
    onSuccess: () => {
      dispatch({
        type: 'SET_SNACKBAR',
        payload: {
          message: `File successfully deleted`,
          state: 'success'
        }
      });
      queryClient.removeQueries(['attachments']);
    },
    onError: (error) => {
      dispatch({
        type: 'SET_SNACKBAR',
        payload: { message: `There was an error deleting attachment, ${error}`, state: 'error' }
      });
    },
    onSettled: () => {
      dispatch({
        type: 'SET_SELECTED_ATTACHMENT_ACTION',
        payload: { delete: null, preview: null }
      });
    }
  });

  const dialogDescription = (
    <Stack sx={{ color: theme.palette.common.grey, rowGap: 1, fontWeight: 400 }}>
      <Box>Are you sure you want to delete</Box>
      <Box>this file?</Box>
    </Stack>
  );
  return (
    <GenericDialog
      isDialogOpen={isDialogOpen}
      setDialogOpen={() => {
        dispatch({
          type: 'SET_SELECTED_ATTACHMENT_ACTION',
          payload: { delete: null, preview: null }
        });
      }}
      title="Delete file?"
      description={dialogDescription}
      buttonCallback={() => deleteAttachment.mutate()}
      callbackLoading={deleteAttachment.isLoading}
      buttonText="Delete"
      url=""
      primaryButtonId="confirm-delete-attachment-button"
      secondaryButtonId="cancel-delete-attachment-button"
    />
  );
}
